import { isIndex } from '@awayfl/swf-loader';
export function qualifyPublicName(v) {
    return isIndex(v) ? v : '$Bg' + v;
}
